module.exports = __webpack_public_path__ + "static/media/avolant.ce50d79a.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/aguacate/climasense/acaro_cristalino_aguacate/curativa/avolant.png
// module id = 1079
// module chunks = 3